import React from 'react';
import { arrayOf, bool, func, shape, string, node } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { Review } from '../Review/Review.component';
import { Overview } from '../Overview/Overview';
import { CustomerImageCarousel } from '../CustomerImageCarousel/CustomerImageCarousel.component';
import { ReviewPager } from '../Paging/ReviewPager.component';
import { Search, Sort } from '../Filter/components';
import { Filter } from '../Filter/Filter.component';
import { Button } from '@thd-olt-component-react/button';
import { Col, Row } from '@thd-olt-component-react/grid';
import { WriteAReview } from '../WriteAReview/WriteAReview.component';
import { ReviewSentiments } from '../Filter/components/ReviewSentiments/ReviewSentiments.component';
import './MobileOverlay.scss';

export const MobileOverlay = ({
    apiKey,
    brandName,
    imageUrl,
    itemId,
    reviewModels,
    reviewStatistics,
    filterCheckboxes,
    noResults,
    onDeselectFilter,
    onFilterChange,
    onPageChange,
    onSearch,
    onSortChange,
    onSentimentChange,
    onSearchClear,
    pagerDisplayText,
    productLabel,
    prosAndCons,
    searchTerm,
    sortBy,
    selected,
    selectedSentiment
  }) => {
  return (
    <>
      <Row className="rr-mobile-overlay">
        <Col fallback={4}>
          <div className="rr-mobile-overlay__product-image">
            <Image
              src={(imageUrl || '').replace('65', '145')}
              alt={productLabel}
              lazy
              width={100}
              height={100}
            />
          </div>
        </Col>
        <Col fallback={8}>
          <div className="rr-mobile-overlay__product-brand">
            {brandName}
          </div>
          <div className="rr-mobile-overlay__product-label">
            {productLabel}
          </div>
        </Col>
      </Row>
      <Overview
        isMobileOverlay
        itemId={itemId}
        reviewStatistics={reviewStatistics}
        filters={[]}
        filterCheckboxes={filterCheckboxes}
        clickableFilters
        onFilterChange={onFilterChange}
      />
      <CustomerImageCarousel itemId={itemId} />
      {prosAndCons ?
        (<ReviewSentiments
          itemId={itemId}
          selectedSentiment={selectedSentiment}
          onSentimentChange={onSentimentChange}
          />): '' }
      <Row className="ratings-and-reviews__search-and-sort">
        <Col xs={12} sm={12} md={4} lg={4} className="ratings-and-reviews__search-and-filter">
          <Search onSearch={onSearch} searchTerm={searchTerm} noResults={reviewModels.length === 0} />
        </Col>
        <Col xs={12} sm={12} md={5} lg={5} className="ratings-and-reviews__search-and-filter">
          <Filter onChange={onFilterChange} ratingFilters={filterCheckboxes} reviewStatistics={reviewStatistics} selectedSentiment={selectedSentiment} />
        </Col>
      </Row>
      <Row className="ratings-reviews__sort-and-filter">
        <Col className="ratings-reviews__sort-and-filter__pager" fallback={7} sm={3} md={3} lg={3} id="search-and-sort">
          {pagerDisplayText({ topPager: true })}
        </Col>
        <Col fallback={5} xs={5} sm={5}>
          <Sort onChange={onSortChange} sortBy={sortBy} />
        </Col>
        {(searchTerm || selected.length > 0)
           && (
          <Col className="ratings-reviews__sort-and-filter__mobile-filter-pill-collection" fallback={12} >
            {selected.length > 0
              && (
                <>
                {selected
                  .map((checkbox, checkboxIndex) => {
                    const pillText =  checkbox.value === 'verified' ? 'Verified Purchases' : `${checkbox.value} Star`;
                    return  (
                      <Button
                        key={checkboxIndex}
                        id={checkbox.id}
                        onClick={()=> { onDeselectFilter(checkbox) }}
                        filter
                      >
                      {selectedSentiment ? selectedSentiment.Feature : pillText}
                      </Button>
                    )
                  }
                )}
                </>
              )}
              {
                searchTerm
                  && (
                    <Button
                    key="search"
                    id="search"
                    onClick={onSearchClear}
                    filter
                    >
                    {noResults && searchTerm ? 'Clear Search Term' : searchTerm}
                    </Button>
                  )
              }
            </Col>
        )}
      </Row>
      {reviewModels.length === 0 ? <div className="loadingBuffer"></div>
        : reviewModels.map((review, reviewIndex) => {
        return (
          <Review
            review={review}
            id={reviewIndex}
            key={`review-${reviewIndex}`}
            apiKey={apiKey}
            searchTerm={searchTerm}
          />
        );
      })}
      <Row className="pager-section--mobile">
        <ReviewPager
          itemId={itemId}
          reviewsPageContext={reviewStatistics.pageContext}
          onPageChanged={onPageChange}
        />
        {pagerDisplayText({ topPager: false })}
      </Row>
    </>
  );
};

MobileOverlay.displayName = 'RatingsAndReviewsMobileOverlay';

MobileOverlay.propTypes = {
  apiKey: string,
  children: node,
  itemId: string,
  mobileReviewsOnFirstPage: arrayOf(shape({})),
  noResults: bool,
  onSearchClear: func.isRequired,
  pagerDisplayText: func.isRequired,
  prosAndCons: bool.isRequired,
  reviewModels: arrayOf(shape({})),
  reviewStatistics: shape({}),
  selected: arrayOf(shape({})),
  target: string
};
MobileOverlay.defaultProps = {
  apiKey: '',
  noResults: true,
};
